import React from 'react';
import { X } from 'lucide-react';
import CompetencySelector, { CompetencyAssignment } from './CompetencySelector';

interface TaskCompetencyModalProps {
  isOpen: boolean;
  onClose: () => void;
  taskId: number;
  taskTitle: string;
  curriculumIds: number[]; // Von Baustein geerbt
  onUpdate?: (assignments?: CompetencyAssignment[]) => void;
}

export default function TaskCompetencyModal({
  isOpen,
  onClose,
  taskId,
  taskTitle,
  curriculumIds,
  onUpdate
}: TaskCompetencyModalProps) {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={(e) => {
        // Close modal when clicking on backdrop
        if (e.target === e.currentTarget) {
          onClose()
        }
      }}
    >
      <div 
        className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between z-10">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Kompetenzen zuordnen</h3>
            <p className="text-sm text-gray-600">{taskTitle}</p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Info über geerbte Curricula */}
          {curriculumIds.length === 0 && (
            <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
              <p className="text-sm text-yellow-800">
                ⚠️ Bitte wählen Sie im Baustein ein Curriculum aus, um Auto-Assign zu nutzen.
              </p>
            </div>
          )}

          {/* CompetencySelector */}
          <CompetencySelector
            entityType="task"
            entityId={taskId}
            curriculumIds={curriculumIds}
            requireCurriculumForAutoAssign={false}
            onUpdate={(assignments) => {
              onUpdate?.(assignments)
              // Don't close modal automatically - let user close it manually
            }}
          />
        </div>
      </div>
    </div>
  )
}

